import { DateTime, Duration } from 'luxon';

export * from './time-input.component';

declare global {
  interface Window {
    DateTime: typeof DateTime;
    Duration: typeof Duration;
  }
}

// expose Luxon for use from Instawork app
window.DateTime = DateTime;
window.Duration = Duration;
